export default __webpack_public_path__ + "static/media/job_offer5_s.2483e7b1.jpg";